/* eslint-disable max-len */

import $ from 'jquery';
import _ from 'underscore';
import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';
import { withoutTime } from '@bingads-webui/primitive-utilities';
import { fromLegacyTimeZone, toIANATimeZone } from '@bingads-webui-universal/time-zone-converter';
import downloadTemplate from './download-template.pug';
import { dateUtils } from '../../hotel-center-utils';

const pageContext = globalContext.require('PageContext');
const edm = globalContext.requireDefault('campaignui/feature/hotel-center-edm/index');
const jsdata = globalContext.require('campaignui/feature/hotel-center-js-data/index');
const { bingadsGridColumn } = globalContext.require('component/bingads-grid/shared/column');
const { showError } = globalContext.require('component/toast/index');

const statusEnumMap = {
  WARNINGS: 'HotelCenter_Intelligence_FeedStatus_Grid_Status_Enum_Warning',
  PENDING: 'HotelCenter_Intelligence_FeedStatus_Grid_Status_Enum_Pending',
  FAILURE: 'HotelCenter_Intelligence_FeedStatus_Grid_Status_Enum_Error',
  SUCCESS: 'HotelCenter_Intelligence_FeedStatus_Grid_Status_Enum_Success',
};

export default class GridConfig {
  constructor({
    i18n,
    dateFilterContainer,
  }) {
    this.i18n = i18n;
    this.name = 'HotelCenterFeedStatusGrid';
    const minDate = withoutTime(dateUtils.local2account(new Date()));

    minDate.setDate(minDate.getDate() - 29);

    this.tableClasses = ['table', 'table-bordered'];
    this.scrolling = {
      virtualized: true,
      viewport: window,
      header: {
        type: 'sticky',
        offset() {
          return $('.navbar-fixed-top').height();
        },
      },
    };
    const entitySet = edm.currentCustomer.Feeds;
    const includeRanges = ['custom', 'customTime', 'today', 'yesterday', 'thisWeekSunday', 'thisWeekMonday', 'lastSevenDays', 'lastWeekSunday', 'lastWeekMonday', 'lastFourteenDays', 'last30Days'];

    this.dataSource = {
      type: 'js-data',
      resource: jsdata.TravelFeed,
      entity: jsdata.TravelFeed,
      primaryKey: 'Id',
      options: {
        entitySet,
        cacheResponse: false,
        afterFindAll: (resources, attrs) => {
          if (_.isArray(attrs)) {
            return attrs;
          }
          showError(i18n.getString('GenericErrorMessage'));
          return [];
        },
      },
      query: {
        // generate startdatetime from date picker
        // hard code feedtype here since we only support one type
        $filter: 'FeedType eq \'transaction\'',
      },
    };

    this.columns = [bingadsGridColumn({
      name: 'TimeStamp',
      property: 'TimeStamp',
      template: (local) => {
        if (_.isEmpty(local.value)) {
          return '';
        }

        return i18n.formatDate(new Date(local.value), {
          datetime: 'full',
          timeZone: toIANATimeZone(fromLegacyTimeZone(pageContext.AccountTimeZone)),
        });
      },
      title: this.i18n.getString('HotelCenter_Intelligence_FeedStatus_Grid_TimeStamp_Label'),
      sortable: true,
    }), bingadsGridColumn({
      name: 'FeedType',
      property: 'FeedType',
      title: 'HotelCenter_Intelligence_FeedStatus_Grid_FeedType_Label',
      helpId: 'Pop_BA_HotelAds_FileType',
      i18n: this.i18n,
    }), bingadsGridColumn({
      name: 'Status',
      property: 'Status',
      title: 'HotelCenter_Intelligence_FeedStatus_Grid_Status_Label',
      helpId: 'Pop_BA_HotelAds_Status',
      template: (local) => {
        /* istanbul ignore next */
        const localizedStatusText = statusEnumMap[local.value] ? this.i18n.getString(statusEnumMap[local.value]) : local.value;
        return localizedStatusText;
      },
      sortable: true,
      i18n: this.i18n,
    }), bingadsGridColumn({
      name: 'ReportUrl',
      property: 'Status',
      template: local => downloadTemplate({
        isDisabled: local.value === 'PENDING',
        displayText: this.i18n.getString('HotelCenter_Intelligence_FeedStatus_Download_Button'),
      }),
      title: 'HotelCenter_Intelligence_FeedStatus_Grid_ReportUrl_Label',
      helpId: 'Pop_BA_HotelAds_File',
      i18n: this.i18n,
    }), bingadsGridColumn({
      name: 'SuccessCount',
      property: 'SuccessCount',
      title: this.i18n.getString('HotelCenter_Intelligence_FeedStatus_Grid_SuccessCount_Label'),
      // helpId: '',
      sortable: true,
    }), bingadsGridColumn({
      name: 'WarningCount',
      property: 'WarningCount',
      title: this.i18n.getString('HotelCenter_Intelligence_FeedStatus_Grid_WarningCount_Label'),
      // helpId: '',
      sortable: true,
    }), bingadsGridColumn({
      name: 'ErrorCount',
      property: 'ErrorCount',
      title: this.i18n.getString('HotelCenter_Intelligence_FeedStatus_Grid_ErrorCount_Label'),
      // helpId: '',
      sortable: true,
    })];

    this.plugins = {
      pagination: {
        pageSize: 20,
        availablePageSizes: [20, 50, 100, 200],
        enableRandomPage: false,
      },

      uiBlocker: {
        el: $('.hotel-center-intelligence-container'),
      },
      placeholder: {
        container: '.grid-noresult',
        text: this.i18n.getString('HotelCenter_Intelligence_FeedStatus_Grid_NoFilteredRecords'),
      },

      dateFilter: {
        container: dateFilterContainer,
        isComparisonEnabled: false,
        minDate,
        odataTimeZone: 'UTC',
        enabledRangesPredicate: range => _.indexOf(includeRanges, range.key) !== -1,
        sharedInGrids: false,
      },
      //   filterState: {
      //     container: $('.hotel-center-global-toolbar-containter .global-filter-bar'),
      //     entity: (() => {
      //       let filterList = ['FeedType'];

      //       return getFilterEntity(feedSchema, filterList);
      //     })(),
      //   },

      // quickFilter: {
      //   toolbar: this.filterToolbar,
      //   items: [{
      //     key: 'all',
      //     text: this.i18n.getString('HotelCenter_Intelligence_FeedStatus_FeedType_Enum_All'),
      //     value: {
      //       query: {
      //         'FeedType': {
      //           $eq: 'all',
      //         },
      //       },
      //     },
      //   }, {
      //     key: 'transaction',
      //     text: this.i18n.getString('HotelCenter_Intelligence_FeedStatus_FeedType_Enum_Transaction'),
      //     value: {
      //       query: {
      //         'FeedType': {
      //           $eq: 'transaction',
      //         },
      //       },
      //     },
      //   }, {
      //     key: 'hints',
      //     text: this.i18n.getString('HotelCenter_Intelligence_FeedStatus_FeedType_Enum_Hints'),
      //     value: {
      //       query: {
      //         'FeedType': {
      //           $eq: 'hints',
      //         },
      //       },
      //     },
      //   }, {
      //     key: 'query_control_message',
      //     text: this.i18n.getString('HotelCenter_Intelligence_FeedStatus_FeedType_Enum_Query_Control'),
      //     value: {
      //       query: {
      //         'FeedType': {
      //           $eq: 'query_control_message',
      //         },
      //       },
      //     },
      //   }],
      // },
    };
  }
}
